<template>
  <div v-if="componentLoader" class="position-relative h-100">
    <app-overlay-loader />
  </div>
  <div v-else>
    <app-overlay-loader v-if="preloader" />
    <div class="company_detail_info">
      <app-tab :tabs="tabsHorizontal" type="horizontal" />
    </div>
  </div>
</template>

<script>
import GlobalHelperMixin from "../../../../Mixins/global/GlobalHelperMixin";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { UserMixin } from "./../Mixins/UserMixin";
import AppLibrary from "../../../../Helpers/AppLibrary";

export default {
  name: "CompanyBusinessDetail",
  extends: AppLibrary,
  mixins: [FormMixin, UserMixin, GlobalHelperMixin],
  data() {
    return {
      icon: "settings",
      tabsHorizontal: [
        {
          name: "Safety Incidents",
          component: "company-safety-incidents",
          permission: "",
          props: {company_id: this.$attrs['props'].companyId}
        },
        {
          name: "Staff Training Details",
          component: "company-staff-trainings",
          permission: "",
          props: {company_id: this.$attrs['props'].companyId}
        },
        {
          name: "Trade Refrence Details",
          component: "company-refrences",
          permission: "",
          props: {company_id: this.$attrs['props'].companyId}
        },
        {
          name: "Trade Association Details",
          component: "company-associations",
          permission: "",
          props: {company_id: this.$attrs['props'].companyId}
        },
      ],
      preloader: false,
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>
